import React from 'react';

export const BasicMetric: React.FC<{ value: any }> = ({ value }) => (
    <div className="text-white text-right">
        {value !== null && value !== undefined ? value : '-'}
    </div>
);

export default BasicMetric;
